<template>
  <div class="register-page">
    <!-- Navigation -->
    <nav class="nav">
      <div class="nav-inner">
        <div class="nav-left">
          <el-image class="nav-logo" style="width: 40px;height: 40px;"
            :src="require('@/assets/img/qhy2.png')"></el-image>
          <span class="nav-name">{{ $siteConfig.siteName }}</span>
        </div>
        <div class="nav-right">
          <button class="btn-text" @click="$router.push('/')">首页</button>
          <button class="btn-primary" @click="$router.push('/login')">登录</button>
        </div>
      </div>
    </nav>

    <!-- Register Form -->
    <section class="register-section">
      <div class="register-bg">
        <div class="blob blob-1"></div>
        <div class="blob blob-2"></div>
      </div>
      <div class="register-content">
        <div class="register-card">
          <div class="register-header">
            <div class="register-badge">
              <app-icon  class="app-icon badge-icon" name="person_add"></app-icon>
              <span>创建新账户</span>
            </div>
            <h1 class="register-title">注册{{ $siteConfig.siteName }}</h1>
            <p class="register-desc">开启您的智能视频创作之旅</p>
          </div>

          <el-form :model="form" :rules="rules" ref="registerForm" class="register-form">
            <div class="form-group">
              <label class="form-label">
                <app-icon  class="app-icon label-icon" name="phone"></app-icon>
                手机号
              </label>
              <el-form-item prop="phone">
                <el-input v-model.number="form.phone" placeholder="请输入手机号" maxlength="11"></el-input>
              </el-form-item>
            </div>

            <div class="form-group">
              <label class="form-label">
                <app-icon  class="app-icon label-icon" name="lock"></app-icon>
                密码
              </label>
              <el-form-item prop="password">
                <el-input type="password" v-model="form.password" placeholder="请输入密码（至少6位）" show-password></el-input>
              </el-form-item>
            </div>

            <div class="form-group">
              <label class="form-label">
                <app-icon  class="app-icon label-icon" name="lock_reset"></app-icon>
                确认密码
              </label>
              <el-form-item prop="confirmPassword">
                <el-input type="password" v-model="form.confirmPassword" placeholder="请再次输入密码" show-password
                  @keyup.native.enter="handleRegister"></el-input>
              </el-form-item>
            </div>

            <div class="form-group">
              <label class="form-label">
                <app-icon  class="app-icon label-icon" name="verified_user"></app-icon>
                人机验证
              </label>
              <SliderVerify @success="onVerifySuccess" @fail="onVerifyFail" />
            </div>

            <div class="form-agreement">
              <el-checkbox v-model="agreed">我已阅读并同意</el-checkbox>
              <el-link type="primary" @click="showTerms = true">《用户条款》</el-link>
              <span>和</span>
              <el-link type="primary" @click="showPrivacy = true">《隐私协议》</el-link>
            </div>

            <el-form-item>
              <button type="button" class="btn-register" @click="handleRegister" :disabled="loading">
                <app-icon v-if="loading"  class="app-icon spinning" name="progress_activity"></app-icon>
                <span v-else>立即注册</span>
              </button>
            </el-form-item>

            <div class="form-footer">
              <span>已有账户？</span>
              <el-link type="primary" @click="$router.push('/login')">立即登录</el-link>
            </div>
          </el-form>
        </div>
      </div>
    </section>

    <!-- Dialogs -->
    <el-dialog title="《用户条款》" :visible.sync="showTerms" append-to-body custom-class="terms-dialog">
      <div style="height: 500px;">
        <iframe :src="`/user_service?appname=${$siteConfig.siteName}&companyname=`" frameborder="0"
          style="width: 100%;height: 100%;"></iframe>
      </div>
    </el-dialog>
    <el-dialog title="《隐私协议》" :visible.sync="showPrivacy" append-to-body custom-class="terms-dialog">
      <div style="height: 500px;">
        <iframe :src="`/yszc?appname=${$siteConfig.siteName}&companyname=`" frameborder="0"
          style="width: 100%;height: 100%;"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SliderVerify from '@/components/common/SliderVerify.vue'

export default {
  name: 'Register',
  components: {
    SliderVerify
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度至少6位'))
      } else {
        if (this.form.confirmPassword) {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }

    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      agreed: false,
      showTerms: false,
      showPrivacy: false,
      isVerified: false,
      form: {
        phone: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onVerifySuccess() {
      this.isVerified = true
    },
    onVerifyFail() {
      this.isVerified = false
    },
    handleRegister() {
      if (!this.isVerified) {
        this.$msg.error('请先完成滑动验证')
        return
      }
      if (!this.agreed) {
        this.$msg.error('请先阅读并同意用户条款和隐私协议')
        return
      }

      this.$refs.registerForm.validate(async (valid) => {
        if (!valid) return

        this.loading = true
        try {
          const res = await this.$ajax.post('api/v1/users/register', {
            password: this.form.password,
            phone: String(this.form.phone),
            upid: parseInt(window.sessionStorage.getItem('upid') || '0') || 0
          })

          if (res.data.access_token) {
            // 注册成功，保存token
            window.localStorage.setItem('token', res.data.access_token)
            // 注册成功后清除邀请信息
            window.sessionStorage.removeItem('upid')

            this.$msg.success('注册成功！')
            this.$alert('注册成功，即将跳转到首页', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: () => {
                this.$router.push('/user2/index')
              }
            })
          } else {
            this.$msg.error(res.data.detail || '注册失败')
          }
        } catch (err) {
          const msg = (err.response && err.response.data && err.response.data.detail) || '注册失败，请稍后重试'
          if (msg.includes('已存在') || msg.includes('已注册')) {
            this.$confirm(msg + '，是否去登录？', '提示', {
              confirmButtonText: '去登录',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/login')
            }).catch(() => {})
          } else {
            this.$msg.error(msg)
          }
        } finally {
          this.loading = false
        }
      })
    }
  },
  created() {
    // 处理推广参数
    const upid = this.$route.query.s || this.$route.query.upid
    if (upid) {
      window.sessionStorage.setItem('upid', upid)
    }
  }
}
</script>

<style scoped>
/* ===== Design Tokens ===== */
.register-page {
  --c-primary: #003ec7;
  --c-primary-container: #0052ff;
  --c-primary-fixed-dim: #1a73e8;
  --c-white: #ffffff;
  --c-deep: #f3f6fb;
  --c-mid: #ffffff;
  --c-slate-300: #475569;
  --c-slate-400: #64748b;
  --font-heading: 'Hanken Grotesk', sans-serif;
  --font-body: 'Inter', sans-serif;
  --font-label: 'Geist', sans-serif;
  --space-xs: 4px;
  --space-base: 8px;
  --space-sm: 12px;
  --space-md: 24px;
  --space-lg: 48px;
  min-height: 100vh;
  background: var(--c-deep);
  color: #1e293b;
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
}

/* ===== Navigation ===== */
.nav {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  background: rgba(246, 249, 253, 0.88);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.05);
}

.nav-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--space-md);
  height: 64px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: var(--space-base);
}

.nav-logo {
  height: 40px;
  width: 40px;
  object-fit: contain;
}

.nav-name {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: var(--space-md);
}

.btn-text {
  background: none;
  border: none;
  color: var(--c-slate-300);
  font-family: var(--font-label);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;
}

.btn-text:hover {
  color: #1e293b;
}

.btn-primary {
  background: var(--c-primary-container);
  color: var(--c-white);
  border: none;
  padding: var(--space-sm) var(--space-lg);
  border-radius: 8px;
  font-family: var(--font-label);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  filter: brightness(1.1);
}

/* ===== Register Section ===== */
.register-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px var(--space-md) var(--space-lg);
  overflow: hidden;
  background: linear-gradient(145deg, #f6f9fd 0%, #eaf1fb 55%, #f3f6fb 100%);
}

.register-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.5;
  animation: blobMove 25s infinite alternate ease-in-out;
}

.blob-1 {
  background: #93c5fd;
  width: 600px;
  height: 600px;
  top: -100px;
  right: -100px;
}

.blob-2 {
  background: #bfdbfe;
  width: 500px;
  height: 500px;
  bottom: -50px;
  left: -50px;
  animation-delay: -10s;
}

@keyframes blobMove {
  0% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(5%, 10%) scale(1.1); }
  100% { transform: translate(-5%, 5%) scale(1); }
}

.register-content {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 440px;
}

/* ===== Register Card ===== */
.register-card {
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 24px 70px rgba(51, 65, 85, 0.12);
}

.register-header {
  text-align: center;
  margin-bottom: 32px;
}

.register-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  padding: 4px 12px;
  background: #eff6ff;
  border-radius: 9999px;
  border: 1px solid #bfdbfe;
  margin-bottom: 16px;
  font-family: var(--font-label);
  font-size: 12px;
  color: var(--c-slate-300);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.badge-icon {
  font-size: 16px;
  color: var(--c-primary-fixed-dim);
}

.register-title {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.register-desc {
  font-size: 14px;
  color: var(--c-slate-400);
  margin: 0;
}

/* ===== Form Styles ===== */
.register-form {
  margin-top: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-label);
  font-size: 13px;
  font-weight: 500;
  color: var(--c-slate-300);
  margin-bottom: 8px;
  letter-spacing: 0.03em;
}

.label-icon {
  font-size: 16px;
  color: var(--c-primary-fixed-dim);
}

/* Element UI Input Override */
.register-form >>> .el-input__inner {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #dbe4f0;
  border-radius: 8px;
  color: #1e293b;
  height: 44px;
  font-size: 14px;
  transition: all 0.2s;
}

.register-form >>> .el-input__inner::placeholder {
  color: var(--c-slate-400);
}

.register-form >>> .el-input__inner:focus {
  border-color: var(--c-primary-container);
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(0, 82, 255, 0.2);
}

.register-form >>> .el-input__prefix {
  color: var(--c-slate-400);
}

.register-form >>> .el-form-item__error {
  font-size: 12px;
  padding-top: 4px;
}

/* Agreement */
.form-agreement {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 24px;
  font-size: 13px;
  color: var(--c-slate-400);
}

.form-agreement >>> .el-checkbox__label {
  color: var(--c-slate-400);
  font-size: 13px;
}

.form-agreement >>> .el-checkbox__inner {
  background: #ffffff;
  border-color: #cbd5e1;
}

.form-agreement >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background: var(--c-primary-container);
  border-color: var(--c-primary-container);
}

.form-agreement >>> .el-link {
  font-size: 13px;
}

/* Register Button */
.btn-register {
  width: 100%;
  height: 48px;
  background: var(--c-primary-container);
  color: var(--c-white);
  border: none;
  border-radius: 10px;
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-register:hover {
  box-shadow: 0 20px 40px -12px rgba(0, 82, 255, 0.4);
  transform: translateY(-2px);
}

.btn-register:active {
  transform: translateY(0);
}

.btn-register:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Footer */
.form-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: var(--c-slate-400);
}

.form-footer >>> .el-link {
  font-size: 14px;
  margin-left: 4px;
}

/* Dialog Override */
.register-page >>> .terms-dialog {
  background: var(--c-mid);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.register-page >>> .el-dialog__title {
  color: #1e293b;
}

.register-page >>> .el-dialog__header {
  border-bottom: 1px solid #e2e8f0;
}

/* ===== Responsive ===== */
@media (max-width: 640px) {
  .nav-inner {
    padding: 0 16px;
  }

  .nav-name {
    font-size: 18px;
  }

  .nav-logo {
    width: 28px !important;
    height: 28px !important;
  }

    .register-section {
      align-items: flex-start;
      padding: 90px 16px 32px;
    }

  .register-card {
    padding: 28px 20px;
  }

  .register-title {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue